import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.css";

const NotFound: React.FC = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.innerContainer}>
        <div className={styles.info}>
          <div className={styles.errorNumber}>404</div>
          <div className={styles.subMessage}>This page must have eloped!</div>
          <Link to="/" className={styles.homeButton}>
            Take me back to the celebration
          </Link>
        </div>
        <img className={styles.couple} src="/assets/animated-couple.gif" alt="Couple animation" />
      </div>
    </section>
  );
};

export default NotFound;
